import * as types from '../../mutation-types'
import { addOrUpdateItem, removeItem } from '../../helpers'

export default {
    [types.ADD_OR_UPDATE_ACTIVITY]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_ACTIVITY]: (state, item) => removeItem(state, item)
}
